var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.998,
    height: 24,
    viewBox: "0 0 23.998 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-performance-6210450",
    transform: "translate(-2.001 -2.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10",
    transform: "translate(2.001 2.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12911",
    "data-name": "Path 12911",
    d: "M20.382,26.429a3.012,3.012,0,0,0-1.845-1.739l-1.707-.569a.3.3,0,0,1-.085-.527,3.851,3.851,0,0,0,1.31-2.98c0-2-1.349-3.614-3.012-3.614s-3.012,1.618-3.012,3.614a3.851,3.851,0,0,0,1.31,2.98.3.3,0,0,1-.084.527l-1.707.569a3.012,3.012,0,0,0-1.844,1.739l-.355.888a.6.6,0,0,0,.559.826H20.178a.6.6,0,0,0,.559-.826Z",
    transform: "translate(-3.045 -4.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12912",
    "data-name": "Path 12912",
    d: "M8.155,25.513a3.814,3.814,0,0,1,2.083-1.671l.231-.077a2.319,2.319,0,0,0-1.226-.96L7.9,22.359a.236.236,0,0,1-.06-.411,3.047,3.047,0,0,0,1.029-2.34A2.635,2.635,0,0,0,6.5,16.77a2.635,2.635,0,0,0-2.366,2.837,3.047,3.047,0,0,0,1.029,2.34.236.236,0,0,1-.06.411L3.758,22.8a2.36,2.36,0,0,0-1.44,1.363l-.283.7a.47.47,0,0,0,.437.643Z",
    transform: "translate(-2.001 -4.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12913",
    "data-name": "Path 12913",
    d: "M28.272,24.167a2.36,2.36,0,0,0-1.44-1.363l-1.346-.446a.236.236,0,0,1-.06-.411,3.047,3.047,0,0,0,1.029-2.34,2.635,2.635,0,0,0-2.366-2.837,2.635,2.635,0,0,0-2.366,2.837,3.047,3.047,0,0,0,1.029,2.34.236.236,0,0,1-.06.411l-1.346.446a2.319,2.319,0,0,0-1.226.96l.231.077a3.814,3.814,0,0,1,2.083,1.671h5.683a.47.47,0,0,0,.437-.643Z",
    transform: "translate(-4.589 -4.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12914",
    "data-name": "Path 12914",
    d: "M23.071,8.36a.995.995,0,0,0,1.689-.583l.583-4.663a.988.988,0,0,0-1.106-1.106l-4.663.583a.995.995,0,0,0-.583,1.689l1.029,1.029-4.329,4.5a.491.491,0,0,1-.669.043L11,6.654a.994.994,0,0,0-1.372.129L3.15,14.326a.993.993,0,0,0,.154,1.44l.36.274A3.261,3.261,0,0,1,6.63,13.8a2.965,2.965,0,0,1,.874.137l3.129-3.489a.505.505,0,0,1,.686-.06l3.737,3.017a1.009,1.009,0,0,0,1.337-.077L22.171,7.46Z",
    transform: "translate(-2.131 -2.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.7c5c662a2e8f386ef0ce92b6dfbe3e95.svg";
export { ForwardRef as ReactComponent };